import React, { useEffect } from 'react';
import styled from 'styled-components';
import isEmpty from 'lodash/isEmpty';

import { textColor, THEME_SECONDARY, THEME_SILVER, themeColor } from '../../../styles/basics/colors';
import { useTranslation } from 'react-i18next';

const heightTextField = '25px';

const StValueTextArea = styled.textarea<{ heightTextField?: number }>`
    border-bottom: 1px solid ${themeColor(THEME_SECONDARY)};
    box-shadow: none !important;
    border-radius: unset !important;
    width: 100%;
    height: ${heightTextField};
    line-height: ${heightTextField};

    ::placeholder {
        ${textColor(THEME_SILVER)};
        font-style: italic !important;
    }

    :focus::placeholder {
        color: transparent;
    }
`;

StValueTextArea.displayName = 'LCFormFieldInputTextarea__StValueTextArea';

function adaptHeight(element, maxHeight) {
    element.style.height = heightTextField;
    element.style.height = `${Math.min(maxHeight, element.scrollHeight)}px`;
}

interface Props {
    value?: string;
    maxLength?: number;
    onValueChange: (value: string) => void;
    textAreaMaxHeight?: number;
}

const LCFormFieldInputTextarea = (props: Props) => {
    const { textAreaMaxHeight = 150 } = props;
    const { t } = useTranslation();

    const textAreaRef = React.useRef<HTMLTextAreaElement>(null);

    useEffect(() => {
        if (textAreaRef.current && !isEmpty(props.value)) {
            adaptHeight(textAreaRef.current, textAreaMaxHeight);
        }
        if (props.value && textAreaRef.current) {
            adaptHeight(textAreaRef.current, textAreaMaxHeight);
        }
    }, [props.value, textAreaMaxHeight]);

    function onTextInput(element) {
        adaptHeight(element, textAreaMaxHeight);
        props.onValueChange(element.value);
    }

    return (
        <StValueTextArea
            maxLength={props.maxLength || undefined}
            data-testid="LCFormFieldInputTextarea"
            aria-label="LCFormFieldInputTextarea"
            defaultValue={props.value || ''}
            placeholder={!props.value ? t('yourLocalContent.yourTitles.none') : ''}
            onChange={event => onTextInput(event.target)}
            ref={textAreaRef}
        />
    );
};

export default LCFormFieldInputTextarea;
